<div [formGroup]="frmGroup">        
    <div [formArrayName]="configData.name" fxFlex class="mat-table mat-elevation-z0"> 
        <div *ngFor="let row of getFormTableControls(); let rowIndex = index" class="row mat-row" >                    
            <div fxFlex="calc(100%-85px)">
              <div class="row" style="margin: 0;">
                <div *ngFor="let control of configData.controls" [formGroupName]="rowIndex" [ngClass]="getColsClass(control.cols)">
                    <app-form-field [configData]="control" [frmGroup]="getFormTableControls()[rowIndex]"></app-form-field>                  
                </div>
              </div> 
            </div>                              
          </div>
    </div>
</div> 
<div style="float: right;">    
    <button type="button" style="margin-right: 14px;" (click)="formReset()"  mat-stroked-button color="warn"  class="dhl-button">Reset</button>
    <button type="button" color="warn" mat-raised-button class="dhl-button" (click)="searchOrderList()">Search</button>
</div>     